import React, { useMemo, useEffect, useState } from "react";
import { formatNumber, rateUsdt } from "../../service";
import { FiBarChart2 } from "react-icons/fi";

const totalReward = 1_000_000_000;

const ReferralDashboard = () => {
    const [data, setData] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await fetch("https://api7.minicorgi.xyz/api/orders/event");
                const json = await res.json();
                setData(json || []);
            } catch (err) {
                console.error("Failed to fetch data:", err);
            }
        };
        fetchData();
    }, []);

    // Tổng doanh thu = tổng price * rateUsdt
    const totalRevenue = useMemo(
        () => data.reduce((sum, d) => sum + d.price * rateUsdt, 0),
        [data]
    );

    const totalSold = data.length;

    // Gom group theo ref
    const refMap = useMemo(() => {
        const map = new Map();
        data.forEach(item => {
            if (!map.has(item.ref)) {
                map.set(item.ref, { total: 0 });
            }
            map.get(item.ref).total += item.price * rateUsdt;
        });
        return map;
    }, [data]);

    // Tổng mua của tất cả KH (đã nhân rateUsdt)
    const totalAll = Array.from(refMap.values()).reduce((sum, obj) => sum + obj.total, 0);

    // BXH, sắp xếp giảm dần theo totalBuy
    const tableData = useMemo(() => {
        return Array.from(refMap.entries())
            ?.map(([ref, { total }], index) => {
                const reward = (total / totalAll) * totalReward;
                return {
                    index: index + 1,
                    ref,
                    totalBuy: total, // đã là VNĐ
                    reward
                };
            })
            .sort((a, b) => b.totalBuy - a.totalBuy);
    }, [refMap, totalAll]);

    return (
        <div className="max-w-4xl mx-auto my-10 p-6 font-sans">
            <h2 className="text-center text-3xl font-bold mb-8 text-gray-800 flex items-center">
                <FiBarChart2 className="text-[--color-button-3]" size={28} />
                Siêu Sao Kết Nối Dashboard
            </h2>

            {/* Cards */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-10">
                <div className="bg-gradient-to-r from-green-600 to-green-700 text-white rounded-xl shadow-lg p-6 text-center">
                    <div className="text-sm opacity-90 mb-2">TỔNG SET ĐÃ BÁN</div>
                    <div className="text-3xl font-extrabold">{totalSold}</div>
                </div>
                <div className="bg-gradient-to-r from-yellow-400 to-yellow-500 text-black rounded-xl shadow-lg p-6 text-center">
                    <div className="text-sm opacity-90 mb-2">DOANH THU</div>
                    <div className="text-3xl font-extrabold">
                        {formatNumber(totalRevenue, 0)} đ
                    </div>
                </div>
            </div>

            {/* Table */}
            <div className="overflow-x-auto bg-white rounded-xl shadow-lg">
                <table className="w-full border-collapse">
                    <thead className="bg-gray-100 text-gray-700 sticky top-0">
                        <tr>
                            <th className="px-4 py-3 border text-center text-sm font-semibold">
                                #
                            </th>
                            <th className="px-4 py-3 border text-center text-sm font-semibold">
                                Mã KH
                            </th>
                            <th className="px-4 py-3 border text-center text-sm font-semibold">
                                Doanh số giới thiệu
                            </th>
                            <th className="px-4 py-3 border text-center text-sm font-semibold">
                                Thưởng MGM (1,000,000,000 đ)
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {tableData?.map((row, idx) => (
                            <tr
                                key={row.ref}
                                className="text-center text-gray-700 hover:bg-gray-50 transition-colors odd:bg-gray-50"
                            >
                                <td className="px-4 py-3 border">{idx + 1}</td>
                                <td className="px-4 py-3 border font-medium">{row.ref}</td>
                                <td className="px-4 py-3 border">
                                    {formatNumber(row.totalBuy, 0)} đ
                                </td>
                                <td className="px-4 py-3 border">
                                    {formatNumber(row.reward, 0)} đ
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>

    );
};


export default ReferralDashboard;
